import { useClientPortalAPI } from "@certn/api";
import { Loader } from "@certn/cascadia-react";
import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useQueryParams } from "../../hooks/useQueryParams";

export function LandingPage() {
  const { params } = useQueryParams();
  const navigate = useNavigate();

  const { error, data, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/packages/ssb-select-package/",
    { package_name: params["package"] }
  );

  const redirectToOrderPage = useCallback(() => {
    if (data) {
      navigate(
        `/order?package_id=${data.package_id}&group_id=${data.customer_group_id}&step=1`
      );
    }
  }, [data, navigate]);

  useEffect(() => {
    if (error || (!isLoading && !data)) {
      navigate("/");
      return;
    }
    redirectToOrderPage();
  }, [data, error, isLoading, navigate, redirectToOrderPage]);

  return <Loader overlay />;
}
